import { render, staticRenderFns } from "./FutureSection.vue?vue&type=template&id=5aad7d53&scoped=true"
import script from "./FutureSection.vue?vue&type=script&lang=js"
export * from "./FutureSection.vue?vue&type=script&lang=js"
import style0 from "./FutureSection.vue?vue&type=style&index=0&id=5aad7d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad7d53",
  null
  
)

export default component.exports